/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Speed_SubInputs */

const en_dialog_premium_speed_sub = /** @type {(inputs: Dialog_Premium_Speed_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free is limited to 1.25`)
};

const es_dialog_premium_speed_sub = /** @type {(inputs: Dialog_Premium_Speed_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis limitado a 1.25`)
};

/**
* | output |
* | --- |
* | "Free is limited to 1.25" |
*
* @param {Dialog_Premium_Speed_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_speed_sub = /** @type {((inputs?: Dialog_Premium_Speed_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Speed_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_speed_sub(inputs)
	return en_dialog_premium_speed_sub(inputs)
});